import "./bootstrap";
import "@/Lib/Interceptors";
import {createApp, h} from "vue";
import App from "@/App";
import Router from "@/Router";
import Store from "@/Store";
import axios from "axios";
import form from "@/Lib/Form";
import notify from "@/Lib/Notify";
import AclChecker from "@/Lib/AclChecker";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

/**
 * Create Vue instance
 * @type {App<Element>}
 */
const index = createApp({render: () => h(App)})
    .use(Store)
    .component('font-awesome-icon', FontAwesomeIcon);

index.config.unwrapInjectedRef = true
index.config.globalProperties.$form = (data = {}, options = {}) => new form(data, options);
index.config.globalProperties.$notify = notify;
index.config.globalProperties.$can = (ability, entity = null, id = null) => {

    if (!Store.getters.authenticated) {
        return false;
    }

    const user = Store.getters.user,
        checker = new AclChecker(user.abilities, user.restrictions);

    return checker.can(ability, entity, id);
};

/**
 * Initialize CSRF protection, fetch the user (if authenticated) and mount the application
 */
axios.get('/sanctum/csrf-cookie')
    .then(async () => {
        if (authenticated) {
            await Store.dispatch('fetchUser');
        }

        if (!window || !window.content) {
            await Store.dispatch('fetchContent');
        } else {
            console.log('steve');
        }
    })
    .catch(console.error)
    .then(() => {
        index.use(Router).mount('#app');
    });
